<template>
  <section class="p-servicemonitor">
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="monitor-wrap">
        <section class="c-mt-84 monitor-title">
          <p class="c-fs-32 c-mb c-fw-b c-c-text-color-dark">服务器&应用监控系统</p>
          <p class="c-fs-16 c-mt-36 c-mb-56 c-lh-38 c-ta-j">MonitorWay 服务器&应用监控系统为 IT 专业人士提供功能强大的应用程序和服务器监控功能，使他们能够更快诊断并排除性能故障。
            不要让运行缓慢的应用程序和停机时间影响您的最终用户和业务服务。跨多层 IT 堆栈找出应用程序问题的根源。监控本地以及公共、私人和混合云环境中的应用程序和服务器。</p>
          <img src="../../assets/monitor/service.jpg" class="c-cs-p" preview="monitor-service"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-84">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">MonitorWay 服务器&应用监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-14 c-c-text-grey c-lh-36 c-mt-40 c-pt-56 c-pl-92 c-pb-68 c-p-r">
            <ul>
              <li>支持 200+ 企业应用程序提供即用型监控模板。</li>
              <li>支持任何自定义或自主开发的应用程序。</li>
              <li>支持带外/带内服务器硬件健康状况。</li>
              <li>支持客户端/无客户端的方式进行监控。</li>
              <li>客户端模式下支持远程脚本执行功能。</li>
            </ul>
            <img src="../../assets/monitor/service-pic.png" class="c-pr-40 pic">
          </div>
        </section>
        <section class="c-pb-164 features">
          <div class="c-d-f c-ai-c c-mt-80">
            <img src="../../assets/index/icon.png">
            <span class="c-ml-12 c-fs-24">功能介绍</span>
          </div>
          <div class="c-d-f c-jc-sb c-fw-w c-mt-40 features-wrap">
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/service1.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">带外/带内资源整合</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">SAM 支持服务器资产的带外/带内资源的整合，将服务器的带外 IPMI 的接口获取的硬件性能信息与带内接口获取的系统性能信息进行关联，统一展示。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/service2.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">服务器性能与存储容量规划</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">通过长期的服务器及应用性能的监控及数据统计，可以合理规划系统资源的分配与扩展，提升 IT 基础设施的使用效率。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item features-special">
              <img src="../../assets/monitor/internet7.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">无代理和基于代理的监控</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">MonitorWay 服务器&应用监控系统是一款无代理软件，您可以用它来监控应用程序、服务器以及内部虚拟基础设施。
                  您也可以部署可选的代理以便将监控扩展到云，例如阿里云、腾讯云、Ucloud、华为云、 Amazon® EC2、Microsoft® Azure 和 Rackspace®。等，
                  代理也可以远程执行脚本，便于部署和修复服务器的相关问题，也可以通过脚本获取对应的应用数据。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/virtual7.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">应用程序依赖关系映射</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">MonitorWay 服务器&应用监控系统通过资产的关联，可以建立从 IT 基础环境到上层的应用、中间件、数据库的关联关系的发现，当业务系统出现故障时，可以快速定位问题的根源。</p>
              </div>
            </div>
            <div class="c-d-f c-jc-sb c-ai-fs c-bc-white features-item">
              <img src="../../assets/monitor/storage2.png">
              <div class="c-ml-40">
                <p class="c-mb-12 c-fs-20 c-c-text-blue">模板化的应用监控</p>
                <p class="c-ta-j c-fs-14 c-lh-28 c-c-text-grey">MonitorWay 服务器&应用监控系统模板库内置 200+ 标准的企业应用监控模板，对于自定义开发的应用，可以在30分钟内通过多种监控的手段实现个性化的模板定制。</p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width monitor-wrap-mobile">
        <section class="c-mt-40 monitor-title">
          <p class="c-fs-19 c-fw-b c-c-text-color-dark">服务器&应用监控系统</p>
          <p class="c-fs-12 c-mt-16 c-mb-24 c-lh-22 c-ta-j">MonitorWay 服务器&应用监控系统为 IT 专业人士提供功能强大的应用程序和服务器监控功能，使他们能够更快诊断并排除性能故障。
            不要让运行缓慢的应用程序和停机时间影响您的最终用户和业务服务。跨多层 IT 堆栈找出应用程序问题的根源。监控本地以及公共、私人和混合云环境中的应用程序和服务器。</p>
          <img src="../../assets/monitor/service.jpg" preview="monitor-service1"/>
        </section>
        <section>
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">MonitorWay 服务器&应用监控系统概览</span>
          </div>
          <div class="c-bc-white c-fs-13 c-c-text-grey c-lh-28 c-mt-24 c-ptb-20 c-pl-36 c-pr-16 c-boxshadow">
            <ul>
              <li>支持 200+ 企业应用程序提供即用型监控模板。</li>
              <li>支持任何自定义或自主开发的应用程序。</li>
              <li>支持带外/带内服务器硬件健康状况。</li>
              <li>支持客户端/无客户端的方式进行监控。</li>
              <li>客户端模式下支持远程脚本执行功能。</li>
            </ul>
          </div>
        </section>
        <section class="features">
          <div class="c-d-f c-ai-c c-mt-40">
            <img class="c-icon-mobile" src="../../assets/index/icon.png">
            <span class="c-ml-8 c-fs-16">功能介绍</span>
          </div>
          <div class="c-mt-24 features-wrap">
              <div class="c-mb-8 features-item">
                <div class="c-bc-white c-d-f c-pe-none">
                  <img src="../../assets/monitor/service1.png">
                  <div class="c-ml-24">
                    <p class="c-fs-15 c-c-text-blue c-mb-8">带外/带内资源整合</p>
                    <p class="c-fs-12 c-lh-20 c-c-text-grey">SAM 支持服务器资产的带外/带内资源的整合，将服务器的带外 IPMI 的接口获取的硬件性能信息与带内接口获取的系统性能信息进行关联，统一展示。</p>
                  </div>
                </div>
              </div>
              <div class="c-mb-8 features-item">
                <div class="c-bc-white c-d-f c-pe-none">
                  <img src="../../assets/monitor/service2.png">
                  <div class="c-ml-24">
                    <p class="c-fs-15 c-c-text-blue c-mb-8">服务器性能与存储容量规划</p>
                    <p class="c-fs-12 c-lh-20 c-c-text-grey">通过长期的服务器及应用性能的监控及数据统计，可以合理规划系统资源的分配与扩展，提升 IT 基础设施的使用效率。</p>
                  </div>
                </div>
              </div>
              <div class="c-mb-8 features-item">
                <div class="c-bc-white c-d-f c-pe-none">
                  <img src="../../assets/monitor/virtual7.png">
                  <div class="c-ml-24">
                    <p class="c-fs-15 c-c-text-blue c-mb-8">应用程序依赖关系映射</p>
                    <p class="c-fs-12 c-lh-20 c-c-text-grey">MonitorWay 服务器&应用监控系统通过资产的关联，可以建立从 IT 基础环境到上层的应用、中间件、数据库的关联关系的发现，当业务系统出现故障时，可以快速定位问题的根源。</p>
                  </div>
                </div>
              </div>
              <div class="c-mb-8 features-item">
                <div class="c-bc-white c-d-f c-pe-none">
                  <img src="../../assets/monitor/storage2.png">
                  <div class="c-ml-24">
                    <p class="c-fs-15 c-c-text-blue c-mb-8">模板化的应用监控</p>
                    <p class="c-fs-12 c-lh-20 c-c-text-grey">MonitorWay 服务器&应用监控系统模板库内置 200+ 标准的企业应用监控模板，对于自定义开发的应用，可以在30分钟内通过多种监控的手段实现个性化的模板定制。</p>
                  </div>
                </div>
              </div>
              <div class="features-item">
                <div class="c-bc-white c-d-f c-pe-none">
                  <img src="../../assets/monitor/internet7.png">
                  <div class="c-ml-24">
                    <p class="c-fs-15 c-c-text-blue c-mb-8">无代理和基于代理的监控</p>
                    <p class="c-fs-12 c-lh-20 c-c-text-grey">MonitorWay 服务器&应用监控系统是一款无代理软件，您可以用它来监控应用程序、服务器以及内部虚拟基础设施。
                      您也可以部署可选的代理以便将监控扩展到云，例如阿里云、腾讯云、Ucloud、华为云、 Amazon® EC2、Microsoft® Azure 和 Rackspace®。等，
                      代理也可以远程执行脚本，便于部署和修复服务器的相关问题，也可以通过脚本获取对应的应用数据。</p>
                  </div>
                </div>
              </div>
          </div>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'service',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.p-servicemonitor {
  @media screen and (min-width: 1180px) {
    min-height: calc(100vh - 90px - 525px);
    background: url('../../assets/monitor/monitor-bg.png') no-repeat;
    background-position: bottom;
    background-size: 100%;
  }
  .monitor-wrap {
    width: 1180px;
    margin: 0 auto;
    .monitor-title {
      img {
        height: 417px;
      }
    }
    .pic {
      position: absolute;
      right: 0;
      top: -90px;
    }
    .features {
      .features-wrap {
        .features-item {
          width: calc(50% - 7px);
          padding: 44px 54px;
          margin-bottom: 14px;
          box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
          border-radius: 1px;
          img {
            width: 18%;
          }
        }
        .features-special {
          width: 100%;
          img {
            width: 10%;
          }
        }
      }
    }
  }
  .monitor-wrap-mobile {
    .monitor-title {
      img {
        // height: 202px;
        width: 100%;
      }
    }
    .features {
      .features-wrap {
        padding-bottom: 40px;
        .features-item {
          width: 100%;
          padding: 25px 16px;
          background: white;
          text-align: justify;
          img {
            width: 38px;
            height: 38px;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>
